export default {
    NOT_FOUND: 'Not Found',
    UNAUTHORIZED: 'Unauthorized',
    UNKNOWN: 'Unknown Error',
    VALIDATION: 'Validation',
    BAD_REQUEST: 'Bad Request',
    PAYMENT_REQUIRED: 'Payment Required',
};